import {
  REMOVE_PRODUCT_FAILED,
  REMOVE_PRODUCT_SUCCESS,
  RESET_REMOVE_PRODUCT,
  LOADING_REMOVE_PRODUCT,
  REMOVE_PRODUCT_INVALID_REQUEST,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_REMOVE_PRODUCT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        status: "",
      };

    case REMOVE_PRODUCT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        status: "Remove cart failed!",
      };
    case REMOVE_PRODUCT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        status: "Oops, Something went wrong!",
      };

    case REMOVE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        status: "Product removed from the cart!",
      };

    case RESET_REMOVE_PRODUCT:
      return (state = initialState);

    default:
      return state;
  }
};
